import {DateTime} from 'luxon';


// set of validators to be used with vuetifies' builtin validation of form/input elements



export default {
   data() {
      return {
      };
   },
   computed: {
   },

   methods: {

      isRequired(x, name='Value', {disabled=false, nullOk=false}={}){
         if (!disabled){
            // let ans = (x  !==null && x !== undefined && ans !== '');
            let ans = !!x;

            if (nullOk && x === null){
               ans = true;
            }

            if (x === false || x === 0){
               ans = true;
            }
            if (Array.isArray((x))){
               if (x.length === 0)
                  ans = false;
            }
            return ans || `${name} is required`;
         }
         else
            return true;

      },

      isNumber(x, disabled=false){
         if (disabled)
            return true;

         let regx = /[+-]?[0-9]+(\.[0-9]+)?([Ee][+-]?[0-9]+)?/;
         return regx.test(x) || 'Must be a number';
      },

      isLessThan(x, y, msg='Check number'){

         if (typeof x ==='string')
            x = x.replace(/,/g, '');
         if (typeof y ==='string')
            y = y.replace(/,/g, '');

         let ans = Number(x) <= Number(y);
         console.log('less', ans, x, y)

         return ans || msg;
      },

      checkEmail(x){
         //regex taken from https://emailregex.com/
         let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         return regx.test(x) || 'E-mail not valid';
      },


      /**
       * converts a date into a luxon datetime obj
       * @param d - ISO str | object with {date, time, timezone} components
       */
      parseDate(d){

         if (typeof d === 'string'){
            return DateTime.fromISO(d)
         }
         else{
            let s = d.date;
            if (d.time != undefined && d.time !== '')
               s += ('T'+d.time);
            else
               s+= 'T00:00';

            if (d.timezone !== undefined && d.timezone !== '' && d.timezone !== null)
               return DateTime.fromISO(s, {zone: d.timezone});
            else
               return DateTime.fromISO(s);
         }

      },


      /**
       * returns true if d1 < d2
       * @param d1 - obj, {date, time, timezone}
       * @param d2 - obj, {date, time, timezone}
       *
       * assumes date has fmt yyyy-mm-dd
       * assumes time has fmt hh:mm:ss
       */
      isDateAfter(d1, d2, txt='Date'){

         d1 = this.parseDate(d1);
         d2 = this.parseDate(d2);

         return d1 < d2 || `${txt} not valid`;



      },

      checkRange(x, low, high, exceptions=[]){

         if (typeof x == 'string')
            x = Number(x);

         // console.log(x, exceptions)
         if (exceptions.includes(x)){
            return true;
         }

         return (x >= low && x <= high) || `Must be between ${low} and ${high}`
      },


      //validation for radio group
      checkRadioGroup(x){
         if (x === null || x === undefined)
            return 'Please select an answer';
         else
            return true;
      }

   }


};
